import React, { useContext } from "react";
import { Form, Label, Input } from "reactstrap";
import { ApiContext } from "../apiContext";

export default function AddForm({
  handleSubmit,
  formError,
  getInputValue,
  handleInputChange,
  handleClear,
  modalData,
  addCase,
  setModalData,
  setCase,
}) {
  const { error } = useContext(ApiContext);

  function safeAtob(value) {
  try {
    if (typeof value === "string" && /^[A-Za-z0-9+/=]+$/.test(value)) {
      return atob(value);
    }
    return value;
  } catch (e) {
    return value;
  }
}


  if (error) {
    return <div>Error: {error.message}</div>;
  }
  return (
    <>
      <Form onSubmit={handleSubmit}>
        <div className="row edit-form">
          <div className="my-3 col-md-12">
            <Label for="name">Name</Label>
            <Input
              type="text"
              id="name"
              name="name"
              placeholder="Enter user name"
              value={getInputValue("name")}
              onChange={(event) => handleInputChange(event, "name")}
            />
            <span className="non-valid">{formError.name}</span>
          </div>

          <div className="my-3 col-md-12">
            <Label htmlFor="title">Email</Label>
            <Input
              type="email"
              id="emailId"
              name="emailId"
              placeholder="Enter email address"
              value={getInputValue("emailId")}
              onChange={(event) => handleInputChange(event, "emailId")}
            />
            <span className="non-valid">{formError.emailId}</span>
          </div>

                    <div className="my-3 col-md-12">
            <Label htmlFor="title">Password</Label>
            <Input
              type="text"
              id="password"
              name="password"
              placeholder="Enter Password"
              value={safeAtob(getInputValue("password"))}
              onChange={(event) => handleInputChange(event, "password")}
            />
            <span className="non-valid">{formError.password}</span>
          </div>

          <div className="my-3 col-md-6">
            <Label htmlFor="status">Status</Label>
            <div className="toggle">
              <span>Inactive</span>
              <label
                className={`switch ${
                  (modalData && modalData.status) || addCase.status
                    ? "true"
                    : ""
                }`}
              >
                <Input
                  type="checkbox"
                  checked={modalData && modalData.status}
                  onChange={() => {
                    if (modalData) {
                      setModalData((prevModalData) => ({
                        ...prevModalData,
                        status: !prevModalData.status,
                      }));
                    } else {
                      setCase((prevAddCase) => ({
                        ...prevAddCase,
                        status: !prevAddCase.status,
                      }));
                    }
                  }}
                />
                <span className="slider round"></span>
              </label>
          
              <span>Active</span>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-warning ms-2"
              onClick={handleClear}
            >
              Clear
            </button>
            <button
              onClick={handleSubmit}
              type="button"
              className="btn btn-primary ms-2"
            >
              Submit
            </button>
          </div>
        </div>
      </Form>
    </>
  );
}
